import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    onWithDirections: translate({ id: 'globalStyles.routePaths.onWithDirections' }),
    on: translate({ id: 'global.on' }),
    off: translate({ id: 'global.off' }),
    routePaths: translate({ id: 'global.routePaths' }),
    noRoutePaths: translate({ id: 'globalStyles.routePaths.noRoutePaths' }),
  }))

  return api
}
